require('packs/basic.js')
require('../home/home.js')
require('../home/owl_carousel.js')